(function(){
    'use strict'

    angular
    .module('app.bancos')
    .controller('Bancos', Bancos);

    Bancos.$inject = ['$animationsSrv', 'BancosService', 'logger', '$location', 'UserInfoService'];

    function Bancos($animationsSrv, BancosService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.bancos = [];
        vm.title = 'Bancos';

        vm.goToEdit = function(banco){
            
            var path = '/editar-banco/';

            if(banco){
                $location.path(path + banco.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = BancosService.getAll();

            promise
            .then(function(bancos){
                vm.bancos = bancos;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los bancos.');
                        break;
                }
            });
        };

        vm.delete = function(banco){
            var promise = BancosService.remove(banco);
            
            promise
            .then(function(response){
                vm.bancos = vm.bancos.filter(function(g) {
                    return g.id !== banco.id;
                });
                logger.success('Banco eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Banco');
                        break;
                }
                
            });   
        };

    }
})();